import { render, staticRenderFns } from "./TheSnackbarStack.vue?vue&type=template&id=5ae83f9f"
import script from "./TheSnackbarStack.vue?vue&type=script&lang=js"
export * from "./TheSnackbarStack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports